// Mobile Menu Toggle
(function () {
  var toggle = document.querySelector('.mobile-menu-toggle');
  var nav = document.querySelector('.mobile-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
    });
  }
})();

// Cart Count
function updateCartCount() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
        el.dataset.count = cart.item_count;
      });
    });
}
updateCartCount();

// Note: the product page (templates/product.liquid) handles its own AJAX
// add-to-cart inline, using the .tt-pdp-form selector and updateCartCount().

// Quantity Buttons (product page)
document.querySelectorAll('.qty-btn').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var input = this.parentElement.querySelector('.qty-input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    if (this.dataset.action === 'minus') input.value = Math.max(1, val - 1);
    if (this.dataset.action === 'plus') input.value = val + 1;
  });
});

// Quantity Buttons (cart page)
document.querySelectorAll('.cart-item__qty-btn').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var input = this.parentElement.querySelector('.cart-item__qty-input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    if (this.dataset.action === 'minus') input.value = Math.max(0, val - 1);
    if (this.dataset.action === 'plus') input.value = val + 1;
  });
});

// Product Gallery Thumbnails
document.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
  thumb.addEventListener('click', function () {
    var mainImg = document.querySelector('.product-gallery__main img');
    if (mainImg && this.dataset.src) mainImg.src = this.dataset.src;
    document.querySelectorAll('.product-gallery__thumb').forEach(function (t) {
      t.classList.remove('active');
    });
    this.classList.add('active');
  });
});

// Collection Sort
var sortSelect = document.getElementById('SortBy');
if (sortSelect) {
  sortSelect.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.value);
    window.location.href = url.toString();
  });
}

// Homepage variant selection
(function () {
  if (!window.landingVariants) return;

  var variants = window.landingVariants;
  var selectedColor = document.querySelector('.color-swatch.active') && document.querySelector('.color-swatch.active').dataset.color;
  var selectedPattern = document.querySelector('[data-pattern].active') && document.querySelector('[data-pattern].active').dataset.pattern;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function findVariant(color, pattern) {
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].option1 === color && variants[i].option2 === pattern) {
        return variants[i];
      }
    }
    return null;
  }

  function updateLanding() {
    var variant = findVariant(selectedColor, selectedPattern);
    if (!variant) return;
    var idInput = document.getElementById('LandingVariantId');
    var priceEl = document.getElementById('LandingPrice');
    var btn = document.getElementById('LandingAddToCart');
    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (btn) {
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    }
  }

  // Color swatch clicks
  document.querySelectorAll('.color-swatch').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      document.querySelectorAll('.color-swatch').forEach(function (s) { s.classList.remove('active'); });
      this.classList.add('active');
      selectedColor = this.dataset.color;
      var label = document.getElementById('SelectedColor');
      if (label) label.textContent = selectedColor;
      updateLanding();
    });
  });

  // Pattern button clicks
  document.querySelectorAll('[data-pattern]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('[data-pattern]').forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
      selectedPattern = this.dataset.pattern;
      var label = document.getElementById('SelectedPattern');
      if (label) label.textContent = selectedPattern;
      updateLanding();
    });
  });

  // Landing page thumbnail gallery
  document.querySelectorAll('.product-landing__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.getElementById('LandingMainImage');
      if (mainImg && this.dataset.src) mainImg.src = this.dataset.src;
      document.querySelectorAll('.product-landing__thumb').forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });
})();
